module.exports = __webpack_public_path__ + "static/media/acero-inoxidable-blank.447cab21.jpg";